import React from 'react';
import { useLocation } from 'react-router-dom';
import { ComponentDocument } from '../../components/signer/ComponentDocument';
import { ComponentAsideDefault } from '../../components/signer/ComponentAsideDefault';
import { ComponentAlerts } from '../../components/signer/ComponentAlerts';
import ModalSeleccionarApariencia from '../../components/signer/modal/ModalSeleccionarApariencia';
import ModalDefinirApariencia from './../../components/signer/modal/ModalDefinirApariencia';

export const SignDocument = ({ fileName }) => {
    const location = useLocation();
    const { alertType, alertMessageKey } = location.state || {};

    return (
        <>
            <main className="main-content main-grid">
                <div>
                    {alertType && alertMessageKey && (
                        <ComponentAlerts alertType={alertType} alertMessageKey={alertMessageKey} />
                    )}
                    <ComponentDocument fileName={fileName} />
                </div>
                <div>
                    <ComponentAsideDefault />
                </div>
            </main>
            <ModalSeleccionarApariencia />
            <ModalDefinirApariencia />
        </>
    );
};
